(function () {
  "use strict";
  // Klaviyo Back in Stock — custom modal that posts to Klaviyo's client endpoints.
  // Loaded (deferred) only when the "Back in stock (Klaviyo)" theme setting is on.
  // Each product section (main-product, featured-product) is wired up independently,
  // so a trigger always opens its own section's modal.
  // Exposes window.themeKlaviyoBis.initSection for AJAX-loaded sections (e.g. quick-buy).
  if (!window.jQuery) return;
  var $ = window.jQuery;
  var REVISION = "2024-06-15";
  var sectionUid = 0;

  function post(path, companyId, body) {
    return fetch(
      "https://a.klaviyo.com/client/" + path + "/?company_id=" + encodeURIComponent(companyId),
      {
        method: "POST",
        headers: { "Content-Type": "application/json", revision: REVISION },
        body: JSON.stringify(body),
      }
    ).then(function (resp) {
      if (resp.ok || resp.status === 202) return resp;
      return resp.json().then(
        function (j) { throw j; },
        function () { throw new Error("Request failed (" + resp.status + ")"); }
      );
    });
  }

  function setupSection($section) {
    if (!$section || !$section.length) return;
    if ($section.attr("data-klaviyo-bis-initialized") === "true") return;

    var $modal = $section.find("[data-klaviyo-bis-modal]");
    if (!$modal.length) return; // this section doesn't use back in stock

    $section.attr("data-klaviyo-bis-initialized", "true");

    var publicKey = $modal.data("public-key");
    var listId = $modal.data("list-id");
    var $form = $modal.find("[data-klaviyo-bis-form]");
    var $email = $form.find('[name="email"]');
    var $optin = $form.find('[name="marketing_optin"]');
    var $message = $modal.find("[data-klaviyo-bis-message]");
    var $submit = $form.find('[type="submit"]');
    var msg = {
      success: $modal.data("msg-success"),
      error: $modal.data("msg-error"),
      submitting: $modal.data("msg-submitting"),
    };
    var $body = $modal.find(".klaviyo-bis-modal__body");
    var bodyTemplate = $modal.data("body-template"); // AP2 modals only
    var lastTrigger = null;
    var modalHome = null;
    var keyNs = "klaviyoBis." + (++sectionUid);

    function currentVariantId() {
      // AP2 cards expose the selected variant on the card element
      if (lastTrigger) {
        var $card = $(lastTrigger).closest("[data-ap2-card]");
        if ($card.length) return $card.attr("data-ap2-selected-variant-id");
      }
      return $section.find('[name="id"]').val();
    }

    function restoreModalHome() {
      if (modalHome && modalHome.parentNode && $modal[0].parentNode !== modalHome) {
        modalHome.appendChild($modal[0]);
      }
      modalHome = null;
    }

    function open(triggerEl) {
      lastTrigger = triggerEl || null;
      // For AP2 cards, show the specific child product name in the modal body
      if (bodyTemplate && lastTrigger) {
        var $card = $(lastTrigger).closest("[data-ap2-card]");
        if ($card.length) {
          $body.text(bodyTemplate.split("[[ product_name ]]").join($card.attr("data-ap2-title-full") || ""));
        }
      }
      // Avoid clipping when nested inside #quick-buy-modal (overflow-y: scroll)
      if (lastTrigger && $(lastTrigger).closest("#quick-buy-modal").length) {
        modalHome = $modal[0].parentNode;
        document.body.appendChild($modal[0]);
      }
      $message.prop("hidden", true).removeClass("is-error is-success").text("");
      $form.show();
      $body.show();
      $email.val("");
      $optin.prop("checked", false);
      $submit.prop("disabled", false);
      $modal.attr("aria-hidden", "false").addClass("is-open");
      setTimeout(function () { $email.trigger("focus"); }, 50);
    }

    function close() {
      $modal.attr("aria-hidden", "true").removeClass("is-open");
      restoreModalHome();
      if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
      lastTrigger = null;
    }

    function destroy() {
      $(document).off("keyup." + keyNs);
      if ($modal.hasClass("is-open")) {
        $modal.attr("aria-hidden", "true").removeClass("is-open");
      }
      restoreModalHome();
      $section.removeAttr("data-klaviyo-bis-initialized");
    }

    function showMessage(isError, text) {
      $message
        .prop("hidden", false)
        .removeClass("is-error is-success")
        .addClass(isError ? "is-error" : "is-success")
        .text(text);
    }

    // Open from this section's trigger
    $section.on("click.klaviyoBis", "[data-klaviyo-bis-trigger]", function (e) {
      e.preventDefault();
      open(this);
    });
    // Close (overlay / close button)
    $modal.on("click.klaviyoBis", "[data-klaviyo-bis-close]", function (e) {
      e.preventDefault();
      close();
    });
    // Esc closes this modal only when it's the open one
    $(document).on("keyup." + keyNs, function (e) {
      if (e.keyCode === 27 && $modal.hasClass("is-open")) close();
    });

    // Clean up when the section node is removed (e.g. quick-buy closes)
    if (typeof MutationObserver !== "undefined") {
      var observer = new MutationObserver(function () {
        if (!document.documentElement.contains($section[0])) {
          observer.disconnect();
          destroy();
        }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }

    $form.on("submit.klaviyoBis", function (e) {
      e.preventDefault();
      var email = $.trim($email.val() || "");
      var variantId = currentVariantId();
      if (!publicKey || !email || email.indexOf("@") === -1 || !variantId) {
        showMessage(true, msg.error);
        return;
      }
      var marketing = $optin.is(":checked");

      var origText = $submit.html();
      $submit.prop("disabled", true).text(msg.submitting || "...");

      var compositeId = "$shopify:::$default:::" + variantId;
      var tasks = [
        post("back-in-stock-subscriptions", publicKey, {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              profile: { data: { type: "profile", attributes: { email: email } } },
              channels: ["EMAIL"],
            },
            relationships: {
              variant: { data: { type: "catalog-variant", id: compositeId } },
            },
          },
        }),
      ];

      if (marketing && listId) {
        tasks.push(
          post("subscriptions", publicKey, {
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: email
                    },
                    subscriptions: {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    }
                  }
                },
                custom_source: "Back in Stock",
              },
              relationships: {
                list: { data: { type: "list", id: listId } },
              },
            },
          })
        );
      }

      Promise.all(tasks)
        .then(function () {
          $form.hide();
          $body.hide();
          showMessage(false, msg.success);
        })
        .catch(function () {
          showMessage(true, msg.error);
        })
        .then(function () {
          $submit.prop("disabled", false).html(origText);
        });
    });
  }

  function init() {
    $("[data-section-type='product-template']").each(function () {
      setupSection($(this));
    });
  }

  window.themeKlaviyoBis = {
    initSection: setupSection,
    init: init,
  };

  $(init);
})();
